import React from 'react';

/**
 * Shared header component for all review question types
 * Question x of x on top row, then type badge left + Report right below
 */
export function ReviewQuestionHeader({ questionType, reportSlot, currentQuestionNumber, totalQuestions, score }) {
  const hasIndicator = currentQuestionNumber != null && totalQuestions != null;

  return (
    <div className="flex flex-col gap-2.5 mb-5 xl:flex-row xl:items-center xl:justify-between xl:relative xl:gap-3 xl:pb-3 xl:border-b-2 xl:border-b-[var(--border-color)] xl:mb-5">
      {hasIndicator && (
        <div className="flex items-baseline justify-between pb-2.5 border-b border-[var(--border-color)] mb-1 xl:absolute xl:left-1/2 xl:-translate-x-1/2 xl:border-b-0 xl:pb-0 xl:mb-0 xl:pointer-events-none xl:justify-center">
          <span className="inline-flex items-baseline gap-0.5 whitespace-nowrap">
            <span className="text-[15px] font-semibold text-[#146e69] dark:text-[#2dd4bf] xl:text-[13px]">Question </span>
            <span className="text-lg font-bold text-[#146e69] dark:text-[#2dd4bf] leading-none xl:text-[15px]">{currentQuestionNumber}</span>
            <span className="text-[13px] font-medium text-[var(--text-secondary)] ml-0.5 xl:text-xs"> of {totalQuestions}</span>
          </span>
          {score != null && (
            <span className="text-[15px] font-bold text-[#146e69] dark:text-[#2dd4bf] whitespace-nowrap xl:hidden">Score: {score}</span>
          )}
        </div>
      )}
      <div className="flex justify-between items-center gap-3 xl:contents">
        <span className="text-sm font-semibold text-[#146e69] dark:text-[#2dd4bf] uppercase tracking-wide shrink-0">{questionType}</span>
        {reportSlot && <div className="shrink-0">{reportSlot}</div>}
      </div>
    </div>
  );
}
